export default "__VITE_ASSET__iH3c_22i__"